import {forwardRef, HTMLProps, Ref} from 'react';

export interface IProps
  extends Omit<HTMLProps<HTMLButtonElement>, 'type' | 'ref'> {}

function Button({className, ...rest}: IProps, ref: Ref<HTMLButtonElement>) {
  return <button className={cn('relative', className)} {...rest} ref={ref} />;
}

export default forwardRef(Button);
